const koSpeakers = require('./ko.json');
const jaSpeakers = require('./ja.json');

export {
  koSpeakers,
  jaSpeakers,
};
